import { ProductViewModel } from '~/lib/data-contract';
import { getImageTags } from './getImageTags';
import { GTMProduct } from '../model';

export const productViewModelMapper = (products: ProductViewModel[]): GTMProduct[] =>
    products.map(
        ({
            productId,
            priceDetails,
            masterCategory,
            engrosColor,
            brand,
            imageTags,
            sizes,
            productType,
            productColorId,
        }) => {
            return ({
                item_sku: productId || null,
                name: `${brand} ${masterCategory} ${engrosColor}`,
                category: masterCategory,
                brand,
                variant: engrosColor,
                price: priceDetails?.googleDisplayPrice,
                id: productId,
                dimension11: sizes?.find((size) => size.inStockOnWeb)?.variantId,
                category_2: productType || '',
                category_3: masterCategory || '',
                variant_id: productColorId || '',
                ...getImageTags(imageTags),
            });
        }
    );
